import * as TYPES from '../types';
import { REDUX_CONSTANT } from '../../constants';

const initialState = {
    isLoading: false
};

export default function getStudentDataForAdmin(state = initialState, action) {
    switch (action.type) {
        case REDUX_CONSTANT.GET_ADMIN_SUBSCRIBER_DATA:
            let adminStudentData =
                action?.payload?.items?.length > 0 ? action.payload.items : [];
            return {
                ...state,
                subscriberDataForAdmin: adminStudentData,
                pageNumber: action.payload.pageNumber,
                pageSize: action.payload.pageSize,
                recordCount: action.payload.recordCount,
                sortOrderForAdmin: action.payload.sortOrder,
                firstNameFieldSearchForAdmin: action.payload.firstName
                    ? action.payload.firstName
                    : '',
                lastNameFieldSearchForAdmin: action.payload.lastName
                    ? action.payload.lastName
                    : '',
                userIdFieldSearchForAdmin: action.payload.userId
                    ? action.payload.userId
                    : '',
                emailAddressFieldSearchForAdmin: action.payload.emailAddress
                    ? action.payload.emailAddress
                    : '',
                isLoading: false
            };

        case REDUX_CONSTANT.GET_ADMIN_STUDENT_DETAILS:
            return {
                ...state,
                selectedStudent: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.GET_ADMIN_STUDENT_ORDER_DETAILS:
            return {
                ...state,
                studentOrderList: action.payload.items,
                studentOrderListRecordCount: action.payload.recordCount,
                productFilterValue: action.payload.productId,
                studentOrderUserId: action.payload.userId,
                isLoading: false
            };
        case REDUX_CONSTANT.GET_MORE_ADMIN_STUDENT_ORDER_DETAILS:
            return {
                ...state,
                isLoading: false,
                studentOrderList:
                    state.studentOrderList && state.studentOrderList.length > 0
                        ? state.studentOrderList.concat(action.payload.items)
                        : action.payload.items,
                studentOrderListRecordCount: action.payload.recordCount
            };

        case REDUX_CONSTANT.ADMIN_STUDENT_ORDER_DETAIL_RESET:
            return {
                ...state,
                studentOrderList: undefined,
                isLoading: false
            };
        case REDUX_CONSTANT.GET_ADMIN_STUDENT_TEST_HISTORY_MORE:
            return {
                ...state,
                isLoading: false,
                allStudentTestHistory:
                    state.allStudentTestHistory &&
                    state.allStudentTestHistory.length > 0
                        ? state.allStudentTestHistory.concat(
                              action.payload.items
                          )
                        : action.payload.items,
                totalAllTestHistoryRecords: action.payload.recordCount
            };

        case REDUX_CONSTANT.GET_ADMIN_STUDENT_TEST_HISTORY_NEW:
            return {
                ...state,
                isLoading: false,
                allStudentTestHistory: action.payload.items,
                totalAllTestHistoryRecords: action.payload.recordCount
            };

        case REDUX_CONSTANT.ADMIN_TEST_RESULT_PROCESSED:
            return {
                ...state,
                isLoading: false,
                adminTestResult: action.payload
            };

        case REDUX_CONSTANT.ADMIN_TEST_RESULT_PDF:
            return {
                ...state,
                isLoading: false,
                adminTestResultPDF: action.payload
            };

        case REDUX_CONSTANT.ADMIN_STUDENT_ORDER_HOLD_DATA:
            return {
                ...state,
                isLoading: false,
                adminStudentOrderHoldValue: action.payload
            };

        case REDUX_CONSTANT.ADMIN_STUDENT_ORDER_OFF_HOLD_DATA:
            return {
                ...state,
                isLoading: false,
                adminStudentOrderOffHoldValue: action.payload
            };

        case REDUX_CONSTANT.ADMIN_STUDENT_DETAIL_RESET:
            return {
                ...state,
                studentOrderList: undefined,
                userProducts: [],
                allStudentTestHistory: [],
                totalAllTestHistoryRecords: 0,
                adminTestResult: [],
                isLoading: false
            };

        case REDUX_CONSTANT.GET_USER_PRODUCTS_DETAILS:
            return {
                ...state,
                userProducts: action.payload.items,
                isLoading: false
            };

        case REDUX_CONSTANT.GET_VENDOR_REFUND_PRODUCT_DATA:
            return {
                ...state,
                refundVendorProduct: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.ADMIN_STUDENT_SEARCH_RESET:
            return {
                ...state,
                subscriberDataForAdmin: [],
                firstNameFieldSearchForAdmin: '',
                lastNameFieldSearchForAdmin: '',
                userIdFieldSearchForAdmin: '',
                emailAddressFieldSearchForAdmin: '',
                recordCount: 0,
                pageNumber: 1,
                subscriberData: [],
                isLoading: false
            };
        case REDUX_CONSTANT.LOGOUT_RESET:
            state = initialState;
            return {
                ...state
            };
        case TYPES.ON_LOAD:
            return {
                ...state,
                isLoading: true
            };
        case TYPES.ERROR:
            return {
                ...state,
                isLoading: false,
                subscriberData:
                    action.payload.title ==
                    REDUX_CONSTANT.GET_ADMIN_SUBSCRIBER_DATA
                        ? []
                        : state.subscriberData,

                studentTestHistory:
                    action.payload.title ==
                    REDUX_CONSTANT.GET_STUDENT_TEST_HISTORY_NEW
                        ? action.payload.msg
                        : state.studentTestHistory,
                subscriberData:
                    action.payload.title == REDUX_CONSTANT.GET_SUBSCRIBER_DATA
                        ? []
                        : state.subscriberData,
                recordCount:
                    action.payload.title == REDUX_CONSTANT.GET_SUBSCRIBER_DATA
                        ? 0
                        : state.recordCount,
                pageNumber:
                    action.payload.title == REDUX_CONSTANT.GET_SUBSCRIBER_DATA
                        ? 1
                        : state.pageNumber,
                redemptionStatus:
                    action.payload.title == REDUX_CONSTANT.GET_SUBSCRIBER_DATA
                        ? ''
                        : state.redemptionStatus,
                subscriptionType:
                    action.payload.title == REDUX_CONSTANT.GET_SUBSCRIBER_DATA
                        ? ''
                        : state.subscriptionType,
                linkStatus:
                    action.payload.title == REDUX_CONSTANT.GET_SUBSCRIBER_DATA
                        ? ''
                        : state.linkStatus,
                selectedStudent:
                    action.payload.title ==
                    REDUX_CONSTANT.GET_ADMIN_STUDENT_DETAILS
                        ? undefined
                        : state.selectedStudent,
                adminStudentOrderHoldValue:
                    action.payload.title ===
                    REDUX_CONSTANT.ADMIN_STUDENT_ORDER_HOLD_DATA
                        ? action.payload.msg
                        : state.adminStudentOrderHoldValue,
                adminStudentOrderOffHoldValue:
                    action.payload.title ===
                    REDUX_CONSTANT.ADMIN_STUDENT_ORDER_OFF_HOLD_DATA
                        ? action.payload.msg
                        : state.adminStudentOrderOffHoldValue,
                vendorOrderRefund:
                    action.payload.title ===
                    REDUX_CONSTANT.GET_VENDOR_REFUND_DATA
                        ? action.payload.msg
                        : state.vendorOrderRefund,
                refundVendorProduct:
                    action.payload.title ===
                    REDUX_CONSTANT.GET_VENDOR_REFUND_PRODUCT_DATA
                        ? action.payload.msg
                        : state.refundVendorProduct,
                refreshSubscriptionData:
                    action.payload.title ===
                    REDUX_CONSTANT.GET_REFRESH_SUBSCRIPTION_DATA
                        ? action.payload.msg
                        : state.refreshSubscriptionData,
                resendInvitationData:
                    action.payload.title ===
                    REDUX_CONSTANT.RESEND_INVITATION_DATA
                        ? action.payload.msg
                        : state.resendInvitationData
            };
        case REDUX_CONSTANT.ISLOADING:
            return {
                ...state,
                isLoading: action.payload
            };
        default:
            return state;
    }
}
